import { render, staticRenderFns } from "./RoundedProperty.vue?vue&type=template&id=1ba6dcc4&"
import script from "./RoundedProperty.vue?vue&type=script&lang=js&"
export * from "./RoundedProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports